import { RunRateType, ScrapYieldType } from '@snap-types/models/enums';
import { stringToEnum } from '@snap-types/util/enum';

export enum VisualScrapYieldType {
  SCRAP = 'S',
  YIELD = 'Y',
}

export const visualScrapYieldTypeSchema = stringToEnum(VisualScrapYieldType);

export const visualScrapYieldTypeToScrapYieldType = {
  [VisualScrapYieldType.SCRAP]: ScrapYieldType.SCRAP,
  [VisualScrapYieldType.YIELD]: ScrapYieldType.YIELD,
} as const satisfies Record<VisualScrapYieldType, ScrapYieldType>;

export const scrapYieldTypeToVisualScrapYieldType = {
  [ScrapYieldType.SCRAP]: VisualScrapYieldType.SCRAP,
  [ScrapYieldType.YIELD]: VisualScrapYieldType.YIELD,
} as const satisfies Record<ScrapYieldType, VisualScrapYieldType>;

export enum VisualRunRateType {
  DAYS_PER_LOAD = 'DAYS/LOAD',
  DAYS_PER_PC = 'DAYS/PC',
  HRS_PER_LOAD = 'HRS/LOAD',
  HRS_PER_PC = 'HRS/PC',
  LOADS_PER_DAY = 'LOADS/DAY',
  LOADS_PER_HR = 'LOADS/HR',
  MIN_PER_PC = 'MIN/PC',
  PCS_PER_DAY = 'PCS/DAY',
  PCS_PER_HR = 'PCS/HR',
  PCS_PER_MIN = 'PCS/MIN',
}

export const visualRunRateTypeSchema = stringToEnum(VisualRunRateType);

export const visualRunRateTypeToRunRateType = {
  [VisualRunRateType.DAYS_PER_LOAD]: RunRateType.DAYS_PER_LOAD,
  [VisualRunRateType.DAYS_PER_PC]: RunRateType.DAYS_PER_PC,
  [VisualRunRateType.HRS_PER_LOAD]: RunRateType.HRS_PER_LOAD,
  [VisualRunRateType.HRS_PER_PC]: RunRateType.HRS_PER_PC,
  [VisualRunRateType.LOADS_PER_DAY]: RunRateType.LOADS_PER_DAY,
  [VisualRunRateType.LOADS_PER_HR]: RunRateType.LOADS_PER_HR,
  [VisualRunRateType.MIN_PER_PC]: RunRateType.MIN_PER_PC,
  [VisualRunRateType.PCS_PER_DAY]: RunRateType.PCS_PER_DAY,
  [VisualRunRateType.PCS_PER_HR]: RunRateType.PCS_PER_HR,
  [VisualRunRateType.PCS_PER_MIN]: RunRateType.PCS_PER_MIN,
} as const satisfies Record<VisualRunRateType, RunRateType>;

export const runRateTypeToVisualRunRateType = {
  [RunRateType.PCS_PER_HR]: VisualRunRateType.PCS_PER_HR,
  [RunRateType.HRS_PER_PC]: VisualRunRateType.HRS_PER_PC,
  [RunRateType.MIN_PER_PC]: VisualRunRateType.MIN_PER_PC,
  [RunRateType.DAYS_PER_PC]: VisualRunRateType.DAYS_PER_PC,
  [RunRateType.HRS_PER_LOAD]: VisualRunRateType.HRS_PER_LOAD,
  [RunRateType.DAYS_PER_LOAD]: VisualRunRateType.DAYS_PER_LOAD,
  [RunRateType.PCS_PER_MIN]: VisualRunRateType.PCS_PER_MIN,
  [RunRateType.PCS_PER_DAY]: VisualRunRateType.PCS_PER_DAY,
  [RunRateType.LOADS_PER_HR]: VisualRunRateType.LOADS_PER_HR,
  [RunRateType.LOADS_PER_DAY]: VisualRunRateType.LOADS_PER_DAY,
} as const satisfies Record<RunRateType, VisualRunRateType>;
